<script setup>
import { useStateStore } from '@/stores/state.store';

const stateStore = useStateStore();
</script>

<template>
  <div class="app" :class="{ 'app-black': stateStore.isBlackTheme }">
    <main>
      <router-view />
    </main>
  </div>
</template>

<style scoped>
main {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 5;
}
</style>
